import Image from 'next/image'
import { ComponentPropsWithoutRef } from 'react'
import { cn } from '~shared/utils/cn'
import { replacePrepositionsWhitespaces } from '~shared/utils/replace-prepositions-whitespaces'

export interface OurMissionSectionProps
  extends ComponentPropsWithoutRef<'section'> {}

export const OurMissionSection = (props: OurMissionSectionProps) => {
  const { className = '', ...rest } = props

  return (
    <section className={cn('container container-slim', className)} {...rest}>
      <div className='relative overflow-hidden rounded-[40px] xl:rounded-[64px]'>
        <div
          className={cn(
            'relative md:absolute px-0 xl:p-[60px] lg:p-[40px] md:p-[24px] bottom-0 md:text-primary md:bg-gradient-to-b md:from-transparent md:to-[rgba(0,0,0,0.5)]',
            'md:px-[42px] lg:px-[71px] xl:px-[215px] '
          )}>
          <h2 className='typo-section-heading text-center'>Наша миссия</h2>
          <p className='typo-section-description mt-[16px] lg:mt-[24px] text-center'>
            {replacePrepositionsWhitespaces(
              'Cоздать систему образования, которая будет доступна каждому.Дистанционное обучение полностью отвечает поставленным целями задачам, поэтому инновационные технологии — неотъемлемая часть образовательного процесса в нашем институте.'
            )}
          </p>
        </div>
        <div className='mt-[30px] md:mt-0 rounded-[40px] overflow-hidden relative z-[-1] md:h-[475px] xl:h-[504px] 2xl:h-[600px]'>
          <Image
            alt='Наша миссия'
            src='/assets/imgs/main-page/our-mission-section.jpg'
            fill
            className='hidden md:block object-cover md:object-top'
          />
          <Image
            alt='Наша миссия'
            src='/assets/imgs/main-page/our-mission-section.jpg'
            width={1065}
            height={600}
            className='w-full md:hidden'
          />
        </div>
      </div>
    </section>
  )
}
